export function OptionItem(value, label) {
    this.value = value;
    this.label = label;

    this.matches = function (keywords) {
        const lowerKeywords = keywords.toLowerCase();
        const lowerValue = this.value.toLowerCase();
        const lowerText = this.label.toLowerCase();

        return lowerValue.indexOf(lowerKeywords) >= 0
            || lowerText.indexOf(lowerKeywords) >= 0;
    }
}